export default __webpack_public_path__ + "static/media/event-image-square.06d2015d.jpg";